// extracted by mini-css-extract-plugin
export var breakpoints = "'../components/breakpoints.css'";
export var tabletUp = "(min-width: 768px)";
export var phoneL = "undefined";
export var posts = "page-module--posts--Z9TDg";
export var singlePost = "page-module--singlePost--xXDnI";
export var blogPosts = "page-module--blogPosts--0CsMK";